import {useMemo} from 'react'
import {BinanceInfo, BybitInfo, OkxInfo} from '../../../apis/user/getKey'
import {JsonView} from 'react-json-view-lite'
import Title from '../../../components/text/Title'

interface IProps {
    className?: string
    data?: BybitInfo | BinanceInfo | OkxInfo
}

const KeySubInfoContainer: React.FC<IProps> = ({className, data}) => {
    const info = useMemo(() => {
        if (data === undefined) {
            return <></>
        }
        return (
            <div className="bg-white rounded-[10px] p-[30px] shadow-normal">
                <Title>Key Info</Title>
                <JsonView
                    data={data}
                    style={{
                        basicChildStyle: '',
                        booleanValue: 'text-gray-400',
                        container: '',
                        expander: '',
                        label: 'text-black-700',
                        nullValue: 'text-red-500',
                        numberValue: 'text-blue-400',
                        otherValue: '',
                        pointer: '',
                        punctuation: '',
                        stringValue: 'text-yellow-600',
                        undefinedValue: 'text-orange-500',
                    }}
                />
            </div>
        )
    }, [data])
    return info
}

export default KeySubInfoContainer
